import { useCopyToClipboard, useDebounceCallback } from "usehooks-ts";
import { cn } from "web-design-system";
import { CopyIcon, CopyCheckIcon } from "lucide-react";
import { useState } from "react";

export function CopyableText({
  text,
  className,
  label,
}: {
  text: string;
  className?: string;
  label?: string;
}) {
  const [, copy] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);

  const reset = useDebounceCallback(() => setIsCopied(false), 2000);

  return (
    <button
      onClick={() => {
        copy(text);
        setIsCopied(true);
        reset();
      }}
      className={cn(
        "max-w-full overflow-hidden py-1 px-1.5 group hover:bg-secondary rounded-md flex gap-2 items-center font-medium",
        className
      )}
    >
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">
        {label || text}
      </span>
      {isCopied ? (
        <CopyCheckIcon className={cn("w-4 shrink-0 h-4 stroke-constructive")} />
      ) : (
        <CopyIcon
          className={cn("w-4 h-4 shrink-0 invisible", "group-hover:visible")}
        />
      )}
    </button>
  );
}
